import * as React from "react";
import { styled } from "@mui/material/styles";
import { darken } from "@mui/system";
import StageStepper from "./StageStepper";

const StageDialogContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down("sm")]: {
        justifyContent: "start",
    },
}));

const DialogContent = styled("div")(({ theme }) => ({
    backgroundColor: darken(theme.palette.background.paper, 0.3),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[15],
    [theme.breakpoints.down("sm")]: {
        boxShadow: "none",
        borderRadius: "unset",
        width: "100%",
    },
}));

const StageStepperWrapper = styled("div")(({ theme }) => ({
    marginTop: -100,
    minWidth: 400,
    [theme.breakpoints.down("sm")]: {
        marginTop: 0,
        width: "100%",
        minWidth: "unset",
    },
}));

const StageDialog = ({ children }: { children: React.ReactNode }) => {
    return (
        <StageDialogContainer>
            <StageStepperWrapper>
                <StageStepper />
            </StageStepperWrapper>
            <DialogContent>{children}</DialogContent>
        </StageDialogContainer>
    );
};

export default StageDialog;
